module.exports = __webpack_public_path__ + "static/media/create_product.0330ba23.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/tutorials/create_product/create_product.png
// module id = 1994
// module chunks = 0